import { ReactNode } from "react";
import { Button, Center, MantineColor, Text } from "@mantine/core";
import { ContextModalProps } from "@mantine/modals";

type ErrorModalProps = {
  title: string;
  text: string;
  icon: ReactNode;
  buttonText: string;
  buttonColor: MantineColor;
};

export const ModalWithTopIcon = ({
  context,
  id,
  innerProps,
}: ContextModalProps<ErrorModalProps>) => (
  <>
    {innerProps.icon && <Center mb="xs">{innerProps.icon}</Center>}
    {innerProps.title && (
      <Text size="xl" mb="xs" sx={{ textAlign: "center", fontWeight: 700 }}>
        {innerProps.title}
      </Text>
    )}
    {innerProps.text && (
      <Text mb="sm" sx={{ textAlign: "center" }}>
        {innerProps.text}
      </Text>
    )}
    <Button
      color={innerProps.buttonColor || "red"}
      fullWidth
      onClick={() => context.closeModal(id)}
    >
      {innerProps.buttonText}
    </Button>
  </>
);
